import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';


import { GLinkDirectivesModule } from 'app/core/directives/directives';
import { GLinkPipesModule } from 'app/core/pipes/pipes.module';

@NgModule({
    imports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        GLinkDirectivesModule,
        GLinkPipesModule
    ],
    exports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        GLinkDirectivesModule,
        GLinkPipesModule
    ]
})
export class CoreSharedModule
{
}
